import React, { Component } from "react";
import { connect } from "react-redux";
import { openEditerAction, openSwAction } from "../../redux/ui/actions";
import {
  changeDsAction,
  changeNewDsAction,
  changeTmpLatAction,
  changeTmpLonAction,
  changeTmpGlAction,
  changeTmpWlAction,
  changeUserDataAction,
  addPointAction,
  changeTmpUserDataAction,
} from "../../redux/boring/actions";
import {
  changeBoringID1Action,
  changeBoringID2Action,
  changeSelRowAction,
  changeDataAction,
  regEditerAction,
  changeMaxIDEditerAction,
  changeUserYScaleEAction,
  changeUserTListAction,
  changeUserYListEAction,
  changeUserBListEAction,
} from "../../redux/editer/actions";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
  return {
    editerSw: state.uiReducer.editerSw,
    geoDs: state.geoReducer.dataset,
    boringDs: state.boringReducer.dataset,
    newDs: state.boringReducer.newDs,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    YScale: state.editerReducer.userYScale,
    tList: state.editerReducer.userTList,
    YList: state.editerReducer.userYList,
    bList: state.editerReducer.userBList,
    isReg: state.editerReducer.isReg,
    selRow: state.editerReducer.selRow,
    isChange: state.editerReducer.isChange,
    regNum: state.boringReducer.regNum,
    estBorSw: state.uiReducer.estBorSw,
    wellsTrData: state.boringReducer.wellsTrData,
    tmpLat: state.boringReducer.tmpLat,
    tmpLon: state.boringReducer.tmpLon,
    tmpGl: state.boringReducer.tmpGl,
    tmpWl: state.boringReducer.tmpWl,
    userData: state.boringReducer.userData,
    tmpUserData: state.boringReducer.tmpUserData,
    name: state.boringReducer.name,
    regMode: state.editerReducer.regMode,
    maxID: state.editerReducer.maxID,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);

    this.scaleWidth = 15; //1目盛 = 15px
    this.maxY = null;
    this.YScale = null;
    this.thkList = [];
    this.YList = [];
    this.boring = null;
    this.boringID1 = this.props.boringID1;
    this.boringID2 = this.props.boringID2;
    this.sameCoordID = null;

    this.createEditer = this.createEditer.bind(this);
    this.createDiag = this.createDiag.bind(this);
    this.changeYScale = this.changeYScale.bind(this);
    this.changeRow = this.changeRow.bind(this);
    this.doOK = this.doOK.bind(this);
    this.closeSw = this.closeSw.bind(this);
    this.addCat = this.addCat.bind(this);
    this.delCat = this.delCat.bind(this);
    this.selRow = null;

    this.tbRef = React.createRef();
    this.$hoverCell = null;

    this.props.dispatch(changeSelRowAction(null));
    this.createEditer(this.boringID1, this.boringID2, null);
    this.state = {
      isCellClicked: false,
    };
    //this.screenInvisible();
  }

  componentDidUpdate(prevProps) {
    /*
     * 選択ボーリング変更
     * @since hara 2020-09-09
     */
    /*
    if (prevProps.boringID1 !== this.props.boringID1 || prevProps.boringID2 !== this.props.boringID2) {
        //行選択解除
        this.tbRef.childNodes.forEach(el => {
            el.classList.remove('selRow');
        });
        this.props.dispatch(changeSelRowAction(null));

        this.boringID1 = this.props.boringID1;
        this.boringID2 = this.props.boringID2;

        this.createEditer(this.boringID1, this.boringID2, null);
    }

    /*
     * エディタ更新
     * @since hara 2020-09-09
     */
    /*
     if (prevProps.newDs !== this.props.newDs && this.props.isChange) {//初期と入力値変更時
         if (this.boring !== null && !this.boring.geo.length)//geoが空の場合、行選択解除
             this.props.dispatch(changeSelRowAction(null));

         this.props.dispatch(changeDataAction(false));
         this.createEditer(this.boringID1, this.boringID2, null);
     }
     */
  }

  /*
   * エディタ作成
   * @param {String} ID1 ボーリングID1
   * @param {String} ID2 ボーリングID2
   * @param {String} selVal 選択された値(初期表示の場合はnull)
   * @since hara 2020-09-09
   */
  createEditer(ID1, ID2) {
    console.log(this.props.userData[ID2]);

    if (this.props.regMode == 1) {
      //修正
      this.boring = JSON.parse(JSON.stringify(this.props.userData[ID2]));
      this.boring.name = this.props.name;
      this.boring.geo = this.boring.geo;
      this.boring.lat = this.boring.lat;
      this.boring.lon = this.boring.lon;
      this.boring.GL = this.boring.GL;
      this.boring.WL = this.boring.WL;
      this.boring.screen = this.boring.screen;
      this.sameCoordID = [];
      this.boring.ido_ID = this.boring.ido_ID;
    } else {
      //新規
      this.boring = [];
      this.boring.name = this.props.name;
      this.boring.geo = [];
      this.boring.lat = 0;
      this.boring.lon = 0;
      this.boring.GL = 0;
      this.boring.WL = 0;
      this.boring.screen = [];
      this.sameCoordID = [];
      if (this.props.userData && Array.isArray(this.props.userData)) {
        this.boring.ido_ID = `${this.props.name}-${this.props.maxID + 1}`;
        this.props.dispatch(changeMaxIDEditerAction(this.props.maxID + 1));
      } else {
        this.boring.ido_ID = `${this.props.name}-${1}`;
        this.props.dispatch(changeMaxIDEditerAction(1));
      }
    }
    const ds = [...this.props.newDs];
    this.props.dispatch(changeTmpLatAction(this.boring.lat));
    this.props.dispatch(changeTmpLonAction(this.boring.lon));
    this.props.dispatch(changeTmpGlAction(this.boring.GL));
    this.props.dispatch(changeTmpWlAction(this.boring.WL));
    this.createTable();
    this.createDiag(true);
  }

  /*
   * テーブル作成
   * @since hara 2020-10-07
   */
  createTable() {
    this.thkList = [];
    let tList = [];
    let preDepThk = 0;

    if (this.boring.geo.length) {
      //geoが空でない場合
      this.boring.geo.forEach((el, index) => {
        const sel = this.props.geoDs[0].geo[el[1] - 1]; //現在は13分類のみ
        let depTd;
        let thkTd;
        let scrTd;
        let thk;

        thk = el[0] - preDepThk;
        //depTd = <input className='textT l-textR' value={(el[0]).toFixed(2)} onChange={e => this.changeField(index, 0, e)} />;/*★公開版で削除 下のコメント解除*/
        depTd = el[0];
        thkTd = <p className="l-textR">{Math.abs(thk).toFixed(2)}</p>;

        preDepThk = el[0];

        scrTd = this.boring.screen[index][0];

        let test = false;
        if (scrTd) {
          test = true;
        }

        this.thkList.push([thk, el[1], this.boring.screen[index]]);
        tList.push(
          <tr id={index} key={index} onClick={(e) => this.changeRow(e)}>
            <td>{sel.ID}</td>
            <td>
              <select
                className="selectT"
                value={sel.ID}
                onChange={(e) => this.changeField(index, 1, e)}
              >
                {this.props.geoDs[0].geo.map((el) => (
                  <option value={el.ID} key={el.ID}>
                    {el.name}
                  </option>
                ))}
              </select>
            </td>
            <td style={{ backgroundColor: sel.color }}></td>
            <td>
              <input
                className="textTR"
                type="text"
                value={Number(depTd)}
                onChange={(e) => this.changeField(index, 0, e)}
              />
            </td>
            <td>{thkTd}</td>
          </tr>
        );
      });
    }
    this.props.dispatch(changeUserTListAction(tList));
  }

  /*
   * フィールド変更
   * @param {Number} rowIndex フィールドの行インデックス
   * @param {Number} geoIndex 0=深度・層厚/1=地質カラーID
   * @param {Event} e イベント情報
   * @since hara 2020-10-07
   */
  changeField(rowIndex, geoIndex, e) {
    if (isNaN(e.target.value)) {
      alert("半角数字を入力してください。");
      return;
    } else if (Number(e.target.value) < 0) {
      alert("深度は正の整数を入力してください。");
      return;
    } else {
      this.boring.geo[rowIndex][geoIndex] = Number(e.target.value);
      this.createTable();
      this.createDiag(true);
    }
  }

  /*
   * セルハイライト
   * @param {Event} e イベント情報
   * @param {String} num IDの番号
   * @since hara 2021-02-25
   */
  hglCell(e, num) {
    //console.log(e)
    if (e === null) {
      //leave時、ハイライト解除
      if (this.$hoverCell !== null)
        this.$hoverCell.classList.remove("cellClick");
      this.$hoverCell = null; // ハイライト解除時に$hoverCellをクリア
    } else {
      //mouseover時、ハイライト
      this.$hoverCell = document.getElementById("boringEdiCell_" + num);
      if (this.$hoverCell.classList.contains("cellClick")) {
        this.$hoverCell.classList.remove("cellClick");
        this.boring.screen[num][0] = false;
      } else {
        this.$hoverCell.classList.add("cellClick");
        this.boring.screen[num][0] = true;
        document.getElementById("scr" + num).checked = true;
      }
    }
    this.createTable();
  }
  /*
   * 図作成
   * @param {Boolean} isInit true=初期値による表示/false=入力値による表示
   * @since hara 2020-09-09
   */
  createDiag(isInit) {
    this.YList = [];
    let bList = null;

    if (this.boring.geo.length) {
      //geoが空でない場合
      this.setScale(isInit);

      const createBoring = () => {
        let li = [];
        this.thkList.forEach((el, index) => {
          li.push(
            <li
              style={{
                backgroundColor: this.props.geoDs[0].geo[el[1] - 1].color,
                height: (el[0] * this.scaleWidth) / this.YScale + "px",
              }}
              key={index}
              id={"boringEdiCell_" + index}
              class={el[2][0] === true ? "cellClick" : ""}
            >
              <div
                className="Boring__wl"
                style={{ top: (el[0] * this.scaleWidth) / this.YScale + "px" }}
              ></div>
            </li>
          );
        });
        return li;
      };

      const drawWl = this.boring.GL - this.boring.WL;
      //地下水位取得
      const getWl = () => {
        if (
          drawWl <= this.maxY &&
          this.boring.WL !== undefined &&
          this.boring.WL !== null
        ) {
          let top = (drawWl * this.scaleWidth) / this.YScale;
          //2 = borderの太さ（border-bottom4px）の半分2px
          top = top - 2;
          return (
            <li className="EditerLgd__wl" style={{ top: top + "px" }}></li>
          );
        } else {
          return null;
        }
      };
      bList = (
        <ul className="EditerLgd__main">
          {createBoring()}
          {getWl()}
        </ul>
      );

      this.createScale(this.YScale, this.maxY);
    }

    this.props.dispatch(changeUserYScaleEAction(this.YScale));
    this.props.dispatch(changeUserYListEAction(this.YList));
    this.props.dispatch(changeUserBListEAction(bList));
  }

  /*
   * 目盛設定
   * @param {Boolean} isInit true=初期値による表示/false=入力値による表示
   * @since hara 2020-09-09
   */
  setScale(isInit) {
    /*
     * Y軸目盛最大値計算
     * return {Boolean} this.maxY Y軸目盛最大値
     * @since hara 2020-09-09
     */
    const calcMaxY = () => {
      this.maxY = 0;
      this.thkList.forEach((el) => {
        this.maxY += el[0];
      });

      return this.maxY;
    };

    if (isInit) {
      //最初は自動で目盛設定
      const root = 16; //rootのフォントサイズ(商用版ではディスプレイサイズによって可変とする)
      const dspH = (24 - 1.2) * root; //24=height24 1.2=padding0.6
      let YScaleNum = Math.floor(dspH / this.scaleWidth);
      this.YScale = Math.ceil((calcMaxY() / YScaleNum) * 10) / 10;
      if (this.YScale < 0.5) {
        //目盛が0.5以下の場合
        this.YScale = 0.5;
      }
    } else {
      //入力値の確認
      if (0.5 <= this.props.YScale) {
        this.YScale = this.props.YScale;
      }
    }
  }

  /*
   * 目盛作成
   * @param {Number} scale 1目盛値
   * @param {Boolean} max 目盛最大値
   * @since hara 2020-09-09
   */
  createScale(scale, max) {
    const num = Math.ceil(max / scale);
    for (let i = 1; i <= num; i++) {
      this.YList.push(
        <li className="scaleY--editer" key={i}>
          {(scale * i).toFixed(window.getDecDig(scale))}
        </li>
      );
    }
  }

  /*
   * パラメータ変更
   * @param {Event} e イベント情報
   * @since ando 2024-12-03
   */
  changePram(e, id) {
    console.log(id);
    switch (id) {
      case "lat": //緯度
        this.props.dispatch(changeTmpLatAction(e.target.value));
        return;
      case "lon": //経度
        this.props.dispatch(changeTmpLonAction(e.target.value));
        return;
      case "gl": //標高
        this.boring.GL = e.target.value;
        this.props.dispatch(changeTmpGlAction(e.target.value));
        return;
      case "wl": //地下水位
        this.boring.WL = e.target.value;
        this.props.dispatch(changeTmpWlAction(e.target.value));
        return;
    }
  }

  /*
   * パラメータチェック
   * @param {Event} e イベント情報
   * @since ando 2024-12-03
   */
  checkPram(e, id) {
    console.log(id);
    if (isNaN(e.target.value)) {
      alert("半角数字を入力してください。");
      return;
    }
    switch (id) {
      case "lat": //緯度
        window.addDelTmpPoint(true, e.target.value, this.props.tmpLon);
        return;
      case "lon": //経度
        window.addDelTmpPoint(true, this.props.tmpLat, e.target.value);
        return;
      case "gl": //標高
        this.createTable();
        this.createDiag(true);
        return;
      case "wl": //地下水位
        this.createTable();
        this.createDiag(true);
        return;
    }
  }
  /*
   * 行追加
   * @since ando 2024-12-03
   */
  addCat() {
    this.boring.geo.push([0, 1]);
    this.boring.screen.push([false]);
    this.createTable();
    this.createDiag(true);
  }

  /*
   * 行削除
   * @since ando 2024-12-03
   */
  delCat() {
    this.boring.geo.splice(this.selRow, 1);
    this.boring.screen.splice(this.selRow, 1);
    this.createTable();
    this.createDiag(true);
  }

  /*
   * 標尺(Y軸)入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeYScale(e) {
    this.props.dispatch(changeUserYScaleEAction(e.target.value));
  }

  /*
   * テーブル選択
   * @param {Event} e イベント情報
   * @since hara 2020-10-08
   */
  changeRow(e) {
    e.target.closest("tbody").childNodes.forEach((el) => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");
    this.selRow = parseInt(tr.id);
    //this.props.dispatch(changeSelRowAction(parseInt(tr.id)));
  }

  /*
   * スクリーン位置列表示非表示
   * @since ando 2023-08-25
   */
  screenInvisible() {
    let tbl = document.getElementById("tmpTbl");
    tbl.style.display = "none";
  }

  /*
   * OKボタン押下時に入力パラメータをチェックする
   * @since ando 2024-12-05
   */
  checkOK() {
    // 層厚0チェック
    for (let index = 0; index < this.boring.geo.length; index++) {
      const el = this.boring.geo[index];

      // 深度が負の場合
      if (Number(el[0]) < 0) {
        alert("深度は正の整数を入力してください。");
        return false; // 関数を終了
      }

      if (index !== 0) {
        // 深度が昇順でない場合
        if (Number(this.boring.geo[index - 1][0]) > Number(el[0])) {
          alert("深度は昇順で入力してください。");
          return false; // 関数を終了
        }
        // 深度が前と同じで層圧が0の場合
        else if (Number(this.boring.geo[index - 1][0]) === Number(el[0])) {
          alert("層厚が0となるデータが存在します。");
          return false; // 関数を終了
        }
      } else {
        // 最初の深度が0の場合
        if (Number(el[0]) === 0) {
          alert("層厚が0となるデータが存在します。");
          return false; // 関数を終了
        }
      }
    }

    // 全てのチェックがOKであれば true を返す
    return true;
  }

  /*
   * ボーリングデータを登録する
   * @since hara 2020-09-09
   */
  doOK() {
    if (this.checkOK()) {
      console.log(this.props.userData);
      //入力データから作成する。
      this.depth = 0;
      this.geo = [];
      this.screen = [];
      this.boring.geo.forEach((el, index) => {
        this.depth += Number(el[0]);
        this.screen.push([false]);
      });
      let regData = {
        ido_ID: this.boring.ido_ID,
        lat: Number(this.props.tmpLat),
        lon: Number(this.props.tmpLon),
        GL: Number(this.props.tmpGl),
        Depth: Number(this.depth),
        WL: Number(this.props.tmpWl),
        geo: this.boring.geo,
        AISCORE: null,
        AISCORE2: null,
        Pomp: null,
        SCORE: null,
        SCORE2: null,
        screen: this.screen,
      };
      const updatedWLTrMeaData = regData;
      // 配列をコピー
      const updatedTrData1 = Array.isArray(this.props.userData)
        ? [...this.props.userData]
        : [];

      const updatedTrData2 = [
        ...(Array.isArray(this.props.userData) ? this.props.userData : []), // 配列でない場合は空の配列にフォールバック
        updatedWLTrMeaData, // 新しいデータを末尾に追加
      ];

      if (this.props.regMode == 1) {
        //修正
        // `ID2` の位置に新しいデータを挿入 (上書き)
        console.log(updatedTrData1[this.props.boringID2]);
        updatedTrData1[this.props.boringID2] = updatedWLTrMeaData;
        // 新しい wellsTrData をセット
        this.props.dispatch(changeUserDataAction(updatedTrData1));
      } else {
        // 新しい wellsTrData をセット
        this.props.dispatch(changeUserDataAction(updatedTrData2));
      }

      this.props.dispatch(openSwAction("boringMain"));
      this.props.dispatch(changeTmpLatAction(0));
      this.props.dispatch(changeTmpLonAction(0));
      this.props.dispatch(changeTmpGlAction(0));
      this.props.dispatch(changeTmpWlAction(0));
      window.addDelTmpPoint(false);
    }
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    console.log(this.props.userData);
    if (this.props.regMode == 0) {
      this.props.dispatch(changeMaxIDEditerAction(this.props.maxID - 1));
    }
    this.props.dispatch(openSwAction("boringMain"));
    this.props.dispatch(changeTmpLatAction(0));
    this.props.dispatch(changeTmpLonAction(0));
    this.props.dispatch(changeTmpGlAction(0));
    this.props.dispatch(changeTmpWlAction(0));
    window.addDelTmpPoint(false);
  }

  render() {
    return (
      <Sw title="ユーザーボーリング" focusName="editer">
        <div className="Editer_wrap l-flex">
          <div>
            {1 < this.sameCoordID.length && (
              <div className="l-row">
                <label>ボーリング：</label>
                <select
                  className="selectL"
                  value={this.boringID1 + "_" + this.boringID2}
                  onChange={(e) =>
                    this.createEditer(
                      e.target.value.split("_")[0],
                      e.target.value.split("_")[1],
                      e.target.value
                    )
                  }
                >
                  {this.sameCoordID.map((el) => (
                    <option value={el} key={el}>
                      {this.props.newDs[el.split("_")[0]].name +
                        " - " +
                        this.props.newDs[el.split("_")[0]].data[
                          el.split("_")[1]
                        ].ido_ID}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div
              className={1 < this.sameCoordID.length ? "l-row l-mtS" : "l-row"}
            >
              <label>名称：</label>
              <div
                className="color2"
                style={{ backgroundColor: this.boring.color }}
              ></div>
              <p>{this.boring.name}</p>
              <label className="l-blank">ID：</label>
              <p>{this.boring.ido_ID}</p>
            </div>

            <div className="l-row l-mtS">
              <label className="" id="">
                緯度：
              </label>
              <input
                className="textSSR"
                type="text"
                value={
                  this.props.tmpLat === undefined || this.props.tmpLat === null
                    ? ""
                    : this.props.tmpLat
                }
                onChange={(e) => this.changePram(e, "lat")}
                onBlur={(e) => this.checkPram(e, "lat")}
              />
              <label className="" id="">
                経度：
              </label>
              <input
                className="textSSR"
                type="text"
                value={
                  this.props.tmpLon === undefined || this.props.tmpLon === null
                    ? ""
                    : this.props.tmpLon
                }
                onChange={(e) => this.changePram(e, "lon")}
                onBlur={(e) => this.checkPram(e, "lon")}
              />
              <label className="" id="">
                孔口標高：
              </label>
              <input
                className="textSSR"
                type="text"
                value={
                  this.props.tmpGl === undefined || this.props.tmpGl === null
                    ? ""
                    : this.props.tmpGl
                }
                onChange={(e) => this.changePram(e, "gl")}
                onBlur={(e) => this.checkPram(e, "gl")}
              />
              <label className="" id="">
                地下水標高：
              </label>
              <input
                className="textSSR"
                type="text"
                value={
                  this.props.tmpWl === undefined || this.props.tmpWl === null
                    ? ""
                    : this.props.tmpWl
                }
                onChange={(e) => this.changePram(e, "wl")}
                onBlur={(e) => this.checkPram(e, "wl")}
              />
            </div>

            <fieldset className="Unit l-mtS">
              <div className="btnWrap">
                {/*
                                <button className='sBtn' onClick={() => this.changeGeo(0)}>挿入</button>
                                */}
                <button className="sBtn l-mlS" onClick={() => this.addCat()}>
                  追加
                </button>
                <button className="sBtn l-mlS" onClick={() => this.delCat()}>
                  削除
                </button>
                {/*
                                <button className='sBtn l-mlS' onClick={() => this.changeGeoIndex(0)}>上</button>
                                <button className='sBtn l-mlS' onClick={() => this.changeGeoIndex(1)}>下</button>
                                */}
                <div className="dividerV"></div>
                <label>標尺 (Y軸)：</label>
                <input
                  className="textS"
                  type="text"
                  value={this.props.YScale}
                  onChange={this.changeYScale}
                />
                <button
                  className="sBtn l-mlS"
                  onClick={() => this.createDiag(false)}
                >
                  適用
                </button>
                <button
                  className="sBtn l-mlS"
                  onClick={() => this.createDiag(true)}
                >
                  初期値
                </button>
              </div>

              <div className="l-flex l-mtS">
                <div className="EditerTWrap" style={{ overflowY: "scroll" }}>
                  <table className="table" id="tmpTbl">
                    <thead>
                      <tr>
                        <th>地質ID</th>
                        <th className="tsM">地質名称</th>
                        <th>地質カラー</th>
                        <th>深度</th>
                        <th>層厚</th>
                      </tr>
                    </thead>
                    <tbody ref={(ref) => (this.tbRef = ref)}>
                      {this.props.tList}
                    </tbody>
                  </table>
                </div>
                <div className="EditerLgd l-mlM">
                  <ul className="EditerLgd__y">{this.props.YList}</ul>
                  {this.props.bList}
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div>
          <div className="l-right l-mtM">
            <button className="cBtn" onClick={this.doOK}>
              OK
            </button>
            <button className="cBtn l-mlS" onClick={this.closeSw}>
              キャンセル
            </button>
          </div>
        </div>
      </Sw>
    );
  }
}

export default connect(mapStateToProps)(Main);
